import Sello from "../assets/img/CEEAV-VERTICAL.png";
import LogoGris from "../assets/img/HORIZONTAL.png";

function Footer() {
  return (
    <>
      <footer
        id="footer"
        className="shadow-sm bg-white border-top--rosa p-4 margin-on-search"
      >
        <div className="container">
          <div className="d-md-flex  align-items-center justify-content-between">
            <div className="d-flex flex-row align-items-center">
              <img className="logoSello ms-5" src={Sello} alt="logo" />
            </div>
            <div className="d-flex flex-column align-items-center">
              <img className="logoGris" src={LogoGris} alt="logo" />
              {/* <div className="text-guinda my-2">#HonestidadyTrabajo</div> */}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
